import BaseModel from '../core/BaseModel'
export default class ProductChangedLogModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_changed_log",
                tableName: 'core_product_changed_log'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Thời gian cập nhật',
                class: 'center',
                sortable: true
            },
            modifier_id: { 
                name: 'modifier_id', 
                type: "Text", 
                label: ' Người cập nhật',
                class: 'center',
                sortable: true,
                computed: (data) => {
                    data.modifier_id = (data.users !== undefined && data.users !== null) ? data.users.full_name: '';
                }
            },
            organization_id: { 
                name: 'organization_id', 
                type: "Text", 
                label: ' Đơn vị cập nhật',
                class: 'center',
                sortable: true,
                computed: (data) => {
                    data.organization_id = (data.organizations !== undefined && data.organizations !== null) ? data.organizations.name: '';
                }
            },
            product_id: {
                refs: 'users { full_name } organizations { name }',
                display: false
            },
            detail: { 
                name: 'detail', 
                type: "Text", 
                label: 'Chi tiết',
                class: 'center',
                callback: true,
                computed: (data) => {
                    data.detail = '<abbr class="external-link">Xem chi tiết</abbr>';
                }
            }
        },)
    }

}